import { z } from 'zod';
/**
 * App V2 is the default UI, and signed-out pages always get it. Once signed in,
 * an organization stays on the retained main frontend only while this PostHog
 * flag answers an explicit false for it. A missing flag, a true value, a user
 * with no organization and every provider error select V2.
 *
 * Owner: Pavit Gogia. Review/expiry: 2026-11-09.
 * Cleanup tracker: https://github.com/Borradh-Media/borradh-workspace/issues/1878.
 * Remove the flag and the retained main frontend once every org is on V2.
 */
export const APP_V2_ROLLOUT_FLAG = 'rollout-app-v2';
/** Local `VITE_DEV_FEATURE_FLAGS` key that forces the main frontend in dev. */
export const APP_UI_DEV_MAIN_KEY = 'app-ui-dev-main';
export const appUiResponseSchema = z.object({
    version: z.enum(['main', 'v2']),
});
//# sourceMappingURL=app-ui.js.map